import PropTypes from 'prop-types';
import React from 'react';
import { ImageProps } from '../../../prop-types';
import { VisuallyHidden } from '../../styled/accessibility';
import { CoveringLink } from '../../styled/links';
import { Card, Info, JobTitle, Name, ImageHolder } from './styles';

/**
 * Displays a contact card with contact information.
 */
const PersonCard = ({
  person,
  link,
  columns,
  showPhotoOnMobile,
  nameAs = 'h4',
}) => {
  const { firstName, lastName, jobTitle, photo } = person;

  return (
    <Card
      $hasLink={!!link}
      $columns={columns}
      as={columns && 'li'}
      data-testid="person-card"
    >
      {link && (
        <CoveringLink
          link={link}
          className="tracking-card"
          dataTracking="people-collection"
        >
          <VisuallyHidden>
            {firstName} {lastName}
          </VisuallyHidden>
        </CoveringLink>
      )}

      {photo && (
        <ImageHolder
          $image={photo}
          data-testid="person-image"
          $showPhotoOnMobile={showPhotoOnMobile}
        />
      )}
      <Info className="card__info">
        <Name as={nameAs}>
          {firstName} {lastName}
        </Name>
        <JobTitle>{jobTitle}</JobTitle>
      </Info>
    </Card>
  );
};

PersonCard.propTypes = {
  person: PropTypes.shape({
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    jobTitle: PropTypes.string,
    photo: ImageProps,
    name: PropTypes.string,
  }),
  link: PropTypes.shape({
    slug: PropTypes.string.isRequired,
  }),
  /** Used to indicate how many columns this card has to fit within */
  columns: PropTypes.number,
  showPhotoOnMobile: PropTypes.bool,
  nameAs: PropTypes.string,
};

export default PersonCard;
